import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  container: {
    width: 400,
  },
  itemHover: {
    cursor: 'pointer',
    padding: '10px 20px',
    ':hover': {
      backgroundColor: theme.palette.neutralLight,
    },
  },
  item: {
    padding: '10px 20px',
    backgroundColor: theme.palette.neutralLighterAlt,
  },
  itemSelected: {
    cursor: 'pointer',
    padding: '10px 20px',
    backgroundColor: theme.palette.neutralQuaternaryAlt,
  },
}));
